<template>
    <div class="user-info">
        <div class="info-box">
            <div class="info-row">
                <div class="col1">
                    <div class="label">姓名：</div>
                    <div class="data">
                        {{storeUser.name ? storeUser.name : "无"}}
                        <!--<span class="icon-wechat" v-if="storeUser.bind_wechat" @click="bindCodeShow = true"></span>-->
                        <span class="no-bind" v-if="storeUser.store_uid && !storeUser.bind_wechat" @click="bindCodeShow = true">未绑定</span>
                    </div>
                </div>
                <div class="col2">
                    <div class="label">手机：</div>
                    <div class="data">{{storeUser.mobile ? storeUser.mobile : "无"}}</div>
                </div>
                <div class="col3">
                    <div class="label">等级：</div>
                    <div class="data">{{storeUser.vip_name ? storeUser.vip_name : "无"}}</div>
                </div>
                <div class="col4">
                    <div class="label">折扣：</div>
                    <div class="data">{{storeUser.discount ? storeUser.discount : "无"}}</div>
                </div>
                <div class="col-block">
                    <div class="label">卡号：</div>
                    <div class="data">{{storeUser.no ? storeUser.no : "无"}}</div>
                </div>
            </div>
            <div class="info-row">
                <div class="col1">
                    <div class="label">有效：</div>
                    <div class="data">{{storeUser.vip_expire ? storeUser.vip_expire : "永久"}}</div>
                </div>
                <div class="col2">
                    <div class="label">积分：</div>
                    <div class="data">{{storeUser.score ? storeUser.score : "0"}}</div>
                </div>
                <div class="col3">
                    <div class="label">卡项：</div>
                    <div class="data">{{storeUser.card_num ? storeUser.card_num : "无"}}</div>
                </div>
                <div class="col4">
                    <div class="label">余额：</div>
                    <div class="data red">{{storeUser.money ? storeUser.money : "0.00"}}</div>
                </div>
                <div class="col-block">
                    <el-button class="h-mini" size="mini" type="primary" @click="payMoneyEvent">充值</el-button>
                    <!--<el-button size="mini" type="primary" @click="editStoreUser">编辑</el-button>-->
                    <el-dropdown trigger="click" @command="handleLogCommand">
                        <el-button class="h-mini" size="mini" type="primary">记录</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="saleHistory">消费记录</el-dropdown-item>
                            <el-dropdown-item command="rechargeHistory">充值记录</el-dropdown-item>
                            <el-dropdown-item command="cardHistory">卡项记录</el-dropdown-item>
                            <el-dropdown-item command="storeUserExtendData">续费记录</el-dropdown-item>
                            <el-dropdown-item command="storeUserGiveHistory">赠送记录</el-dropdown-item>
                            <el-dropdown-item command="storeUserChangeMoneyHistory">调账记录</el-dropdown-item>
                            <el-dropdown-item command="storeUserMoneyData">余额对账</el-dropdown-item>
                            <el-dropdown-item command="storeUserScoreHistory">积分记录</el-dropdown-item>
                            <el-dropdown-item command="storeUserArrearsHistory">欠还记录</el-dropdown-item>
                            <el-dropdown-item command="wechatBindHistory">绑定记录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown trigger="click" @command="handleCommand">
                        <el-button class="h-mini" size="mini" type="primary">更多</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="editStoreUser">修改资料</el-dropdown-item>
                            <el-dropdown-item command="setPayPassword">修改密码</el-dropdown-item>
                            <el-dropdown-item command="seePayPassword">查看密码</el-dropdown-item>
                            <el-dropdown-item command="seeStoreBindCode">查看绑定码</el-dropdown-item>
                            <el-dropdown-item command="storeUserExtend">会员续费</el-dropdown-item>
                            <el-dropdown-item command="storeUserRepayment">会员还款</el-dropdown-item>
                            <el-dropdown-item command="storeUserShow">会员详情</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="info-row">
                <div class="col1">
                    <div class="label">欠款：</div>
                    <div class="data">{{storeUser.arrears ? storeUser.arrears : 0}}</div>
                </div>
                <div class="col-block">
                    <div class="label">备注：</div>
                    <div class="data">{{storeUser.remarks ? storeUser.remarks : "无"}}</div>
                </div>
            </div>

        </div>

        <!--充值-->
        <pay-money v-model="payMoneyShow" :store-uid="storeUser.store_uid" @settleOver="settleOver"></pay-money>
        <!--编辑-->
        <store-user-edit v-model="editShow" :store-uid="storeUser.store_uid" @changeData="updateUserInfo()"></store-user-edit>
        <!--查看消费密码-->
        <see-pay-password v-model="seePayPasswordShow" :store-uid="storeUser.store_uid" />
        <!--修改消费密码-->
        <set-pay-password v-model="setPayPasswordShow" :store-uid="storeUser.store_uid" />
        <!--会员续期-->
        <store-user-extend v-model="storeUserExtendShow" :user-info="storeUser" @onOver="updateUserInfo()" />
        <!--会员还款-->
        <store-user-repayment v-model="storeUserRepaymentShow" :store-uid="storeUser.store_uid" :arrears="storeUser.arrears" @onSuccess="updateUserInfo" />

        <!--会员消费记录-->
        <store-user-sale-history v-model="storeUserSaleHistoryShow" :store-uid="storeUser.store_uid" />
        <!--会员充值记录-->
        <store-user-recharge-history v-model="storeUserRechargeHistoryShow" :store-uid="storeUser.store_uid" />
        <!--卡项记录-->
        <card-sale-history-for-cash v-model="cardHistoryShow" :store-uid="storeUser.store_uid" />
        <!--续期记录-->
        <store-user-extend-data v-model="storeUserExtendDataShow" :store-uid="storeUser.store_uid" />
        <!--赠送记录-->
        <store-user-give-history v-model="storeUserGiveHistoryShow" :store-uid="storeUser.store_uid" />
        <!--调账记录-->
        <store-user-change-money-history v-model="storeUserChangeMoneyHistoryShow" :store-uid="storeUser.store_uid" />
        <!--会员对账-->
        <store-user-money-data v-model="storeUserMoneyDataShow" :store-uid="storeUser.store_uid" />
        <!--会员详情-->
        <store-user-info v-model="storeUserInfoShow" :store-uid="storeUser.store_uid" />
        <!--积分记录-->
        <store-user-score-history v-model="storeUserScoreHistoryShow" :store-uid="storeUser.store_uid" />
        <!--绑定记录-->
        <store-user-bind-history v-model="wechatBindHistoryShow" :store-uid="storeUser.store_uid" />
        <!--欠还记录-->
        <store-user-arrears-history v-model="storeUserArrearsHistoryShow" :store-uid="storeUser.store_uid" />

        <!--绑定码-->
        <StoreUserBindCode v-model="bindCodeShow" :store-uid="storeUser.store_uid" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PayMoney from "@/model/Cash/PayMoney";
    import StoreUserEdit from "@/model/StoreUser/StoreUserEdit";
    import StoreUserHistory from "@/model/StoreUser/StoreUserHistory";
    import PopForm from "@/model/PopForm";
    import StoreUserHistoryBox from "@/model/Cash/StoreUserHistoryBox";
    import SeePayPassword from "@/model/StoreUser/SeePayPassword";
    import SetPayPassword from "@/model/StoreUser/SetPayPassword";
    import StoreUserExtend from "@/model/StoreUser/StoreUserExtend";
    import StoreUserExtendData from "@/model/StoreUser/StoreUserExtendData";
    import StoreUserMoneyData from "@/model/StoreUser/StoreUserMoneyData";
    import StoreUserSaleHistory from "@/model/StoreUser/StoreUserSaleHistory";
    import StoreUserRechargeHistory from "@/model/StoreUser/StoreUserRechargeHistory";
    import StoreUserInfo from "@/model/StoreUser/StoreUserInfo";
    import StoreUserGiveHistory from "@/model/StoreUser/StoreUserGiveHistory";
    import StoreUserChangeMoneyHistory from "@/model/StoreUser/StoreUserChangeMoneyHistory";
    import StoreUserScoreHistory from "@/model/StoreUser/StoreUserScoreHistory";
    import StoreUserBindHistory from "@/model/StoreUser/StoreUserBindHistory";
    import CardSaleHistoryForCash from "@/model/Card/CardSaleHistoryForCash";
    import StoreUserBindCode from "@/model/StoreUser/StoreUserBindCode";
    import StoreUserRepayment from "@/model/Cash/StoreUserRepayment";
    import StoreUserArrearsHistory from "@/model/StoreUser/StoreUserArrearsHistory";
    export default {
        name: "UserInfo",
        components: {
            StoreUserArrearsHistory,
            StoreUserRepayment,
            StoreUserBindCode,
            CardSaleHistoryForCash,
            StoreUserBindHistory,
            StoreUserScoreHistory,
            StoreUserChangeMoneyHistory,
            StoreUserGiveHistory,
            StoreUserInfo,
            StoreUserRechargeHistory,
            StoreUserSaleHistory,
            StoreUserMoneyData,
            StoreUserExtendData,
            StoreUserExtend,
            SetPayPassword,
            SeePayPassword, StoreUserHistoryBox, PopForm, StoreUserHistory, StoreUserEdit, PayMoney},
        props: ["userInfo"],
        data: () => ({
            show: false,
            payMoneyShow: false,
            editShow: false,   //编辑框显示状态
            storeUser: {},
            seePayPasswordShow: false,       //查看支付密码
            setPayPasswordShow: false,       //修改密码
            storeUserExtendShow: false,      //会员续费
            storeUserExtendDataShow: false,  //会员续费记录
            storeUserMoneyDataShow: false,   //会员对账
            storeUserSaleHistoryShow: false, //会员消费记录
            storeUserRechargeHistoryShow: false,    //会员充值记录
            storeUserInfoShow: false,        //会员详情
            storeUserGiveHistoryShow: false,    //赠送记录
            storeUserChangeMoneyHistoryShow: false, //调账记录
            storeUserScoreHistoryShow: false,       //积分记录
            wechatBindHistoryShow: false,           //绑定记录
            cardHistoryShow: false,                 //卡项纪录
            storeUserRepaymentShow: false,          //会员还款
            storeUserArrearsHistoryShow: false,     //欠还记录

            bindCodeShow: false,                    //绑定码显示
        }),
        mounted: function () {
            this.setStoreUser(this.userInfo);
        },
        methods: {
            //会员信息赋值
            setStoreUser: function (userInfo) {
                if(!userInfo.is_vip && !obj.isEmpty(userInfo.vip_id))
                    obj.message.error("会员已过期");

                this.updateUserInfo();
            },
            //显示充值
            payMoneyEvent: function () {
                this.payMoneyShow = true;
            },
            //更新用户信息
            updateUserInfo: function () {
                if(obj.isEmpty(this.userInfo.store_uid)) {
                    this.storeUser = {};
                    return false;
                }

                obj.postData("store_user/get_store_user_info", {id: this.userInfo.store_uid}, res => {
                    if(res.errcode === 0){
                        res.data.store_uid = res.data.id;
                        this.storeUser = res.data;
                        this.$emit("update", this.storeUser);
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },

            //结算完成
            settleOver: function () {
                this.updateUserInfo();
            },

            //记录
            handleLogCommand: function (command) {
                switch (command) {
                    case "saleHistory":
                        //消费记录
                        this.storeUserSaleHistoryShow = true;
                        break;
                    case "rechargeHistory":
                        //充值记录
                        this.storeUserRechargeHistoryShow = true;
                        break;
                    case "storeUserExtendData":
                        //续费记录
                        this.storeUserExtendDataShow = true;
                        break;
                    case "storeUserMoneyData":
                        //会员对账
                        this.storeUserMoneyDataShow = true;
                        break;
                    case "storeUserChangeMoneyHistory":
                        //调账记录
                        this.storeUserChangeMoneyHistoryShow = true;
                        break;
                    case "storeUserGiveHistory":
                        //赠送记录
                        this.storeUserGiveHistoryShow = true;
                        break;
                    case "storeUserScoreHistory":
                        //积分记录
                        this.storeUserScoreHistoryShow = true;
                        break;
                    case "wechatBindHistory":
                        //绑定记录
                        this.wechatBindHistoryShow = true;
                        break;
                    case "cardHistory":
                        //卡项记录
                        this.cardHistoryShow = true;
                        break;
                    case "storeUserArrearsHistory":
                        //欠还记录
                        this.storeUserArrearsHistoryShow = true;
                        break;
                    default:
                        break;
                }
            },
            //更多选择事件
            handleCommand: function (command) {
                switch (command) {
                    case "editStoreUser":
                        //修改会员资料
                        this.editShow = true;
                        break;
                    case "seePayPassword":
                        //查看消费密码
                        this.seePayPasswordShow = true;
                        break;
                    case "setPayPassword":
                        //设置消费密码
                        this.setPayPasswordShow = true;
                        break;
                    case "storeUserExtend":
                        //会员续期
                        this.storeUserExtendShow = true;
                        break;
                    case "storeUserShow":
                        //会员详情
                        // this.$root.go("user/user_info_show", {id: this.storeUser.store_uid}, true);
                        this.storeUserInfoShow = true;
                        break;
                    case "seeStoreBindCode":
                        //查看绑定码
                        this.bindCodeShow = true;
                        break;
                    case "storeUserRepayment":
                        //会员还款
                        this.storeUserRepaymentShow = true;
                        break;
                    default:
                        break;
                }
            },
        },
        watch: {
            userInfo: function (newData) {
                this.setStoreUser(newData);
            }
        }
    }
</script>

<style scoped>
    .user-info{

    }
    .user-info>.info-box{
        display: flex;
        flex-flow: column nowrap;
        border-top: 1px solid #ebedf0;
        border-right: 1px solid #ebedf0;
    }
    .info-box>.info-row{
        display: flex;
        flex-flow: row nowrap;
        border-bottom: 1px solid #ebedf0;
    }
    .info-row>.col1,.info-row>.col2,.info-row>.col3,.info-row>.col4,.info-row>.col5,.info-row>.col-block{
        border-left: 1px solid #ebedf0;
        display: flex;
        flex-flow: row nowrap;
        padding: 8px 15px;
        align-items: center;
        overflow: hidden;
    }
    .info-row>.col1{
        width: 160px;
    }
    .info-row>.col2{
        width: 138px;
    }
    .info-row>.col3{
        width: 151px;
    }
    .info-row>.col4{
        width: 116px;
    }
    .info-row>.col5{
        width: 267px;
    }
    .info-row>.col-block{
        /*width: 863px;*/
        flex: 1;
    }
    .info-row .label{
        min-width: 42px;
    }
    .el-dropdown{
        margin-left: 10px;
    }
    .icon-wechat{
        display: inline-block;
        width: 20px;
        height: 16px;
        background: url("../../images/icon/icon_wechat.png") no-repeat;
        background-size: 100% 100%;
    }
    .h-mini{
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .no-bind{
        color: #ff0000;
    }
    .no-bind:hover, .icon-wechat:hover{
        color: #ff5b5b;
        cursor: pointer;
    }
</style>
